var _defs, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesImagesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-images-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-images-icon_svg__cls-3{stroke-width:0}.websites-images-icon_svg__cls-6{stroke:#010101;stroke-miterlimit:10;stroke-width:2px}.websites-images-icon_svg__cls-3{fill:#fff}.websites-images-icon_svg__cls-6{fill:none}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.44,
    cy: 29.93,
    r: 21,
    strokeWidth: 0,
    fill: "#f9d8cd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "websites-images-icon_svg__cls-3",
    d: "M26.43 17.93h38v27h-38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "websites-images-icon_svg__cls-3",
    d: "M7.43 25.93h38v27h-38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "websites-images-icon_svg__cls-6",
    d: "M57.43 44.93h7v-27h-38v5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "websites-images-icon_svg__cls-6",
    d: "M45.43 30.93v-5h-38v27h7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.43 33.93h37v27h-37z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.43,
    cy: 41.93,
    r: 3,
    fill: "#e9eaeb",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e84b0f",
    strokeWidth: 0,
    d: "M41.43 48.93l-3.5 3.5-7.5-7.5-13 13v3h36l-12-12z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "websites-images-icon_svg__cls-6",
    d: "M41.43 55.93l-11-11-13 13v3h36l-12-12-3 3"
  })));
}
export default SvgWebsitesImagesIcon;